export class UserProps {
  userSessionToken: string
  userRefreshToken: string
  userTokenExpiresOn: string
  userTokenLife: number
  userRefreshTokenExpiresOn?: number

  constructor(
    userSessionToken?: string,
    userRefreshToken?: string,
    userTokenExpiresOn?: string,
    userTokenLife?: number,
    userRefreshTokenExpiresOn?: number
    ) {

    this.userSessionToken = userSessionToken
    this.userRefreshToken = userRefreshToken
    this.userTokenExpiresOn = userTokenExpiresOn
    this.userTokenLife = userTokenLife
    this.userRefreshTokenExpiresOn = userRefreshTokenExpiresOn
  }



}
